// Polskie teksty statyczne UI. Klucze muszą być identyczne z locales/en.js
// (pilnuje tego test src/i18n/__tests__/i18n.test.js).
//
// Teksty pochodzące z API (nazwy hoteli, wycieczek, imiona i nazwiska, komunikaty błędów
// z backendu) NIE trafiają tutaj - są renderowane tak, jak przyszły z serwera.

export const pl = {
   common: {
      appTitle: "Panel rezydenta — Harmonogram zadań",
      warning: "Uwaga!",
      // react-select renders its own English "Select..." when no placeholder is given.
      selectDestination: "Wybierz kierunek",
      selectDay: "Wybierz dzień",
      language: "Język",
      actions: {
         cancel: "Anuluj",
         saveChanges: "Zapisz zmiany",
         back: "Cofnij",
         ok: "Ok",
         yes: "Tak",
         no: "Nie",
         yesUpper: "TAK",
         noUpper: "NIE"
      }
   },

   menu: {
      dataSynced: "Dane zsynchronizowane",
      logout: "Wyloguj",
      logoutConfirm: "Czy napewno chcesz sie wylogować?"
   },

   auth: {
      accessDeniedTitle: "Brak dostępu",
      accessDeniedMessage: "Nie masz uprawnień do wyświetlenia tej strony.",
      notFoundTitle: "404 - Nie znaleziono strony",
      notFoundMessage: "Strona, której szukasz, nie istnieje."
   },

   scheduler: {
      title: "Harmonogram zadań",
      noDestinations: "Brak kierunków wycieczek",
      selectAll: "Zaznacz wszystko",
      animatorNamePlaceholder: "Imię i nazwisko",
      clearSchedule: "Wyczyść harmonogram",
      copyToNextWeek: "Kopiuj na kolejny tydzień",
      confirmAndCopy: "Zatwierdź i kopiuj",
      confirm: {
         removeUser: "Czy na pewno chcesz usunąć osobę z harmonogramu?",
         clearSchedule: "Czy na pewno chcesz wyczyścić harmonogram?"
      }
   },

   copySchedule: {
      overwriteHeader: "Kopiowanie z nadpisywaniem",
      confirmContinue: "Tak, kontynuuj",
      conflictIntro: "Użytkownicy, którzy mają zajęte terminy w kolejnym tygodniu:<br>",
      conflictWarning:
         "<br><br>Kontynuacja spowoduje nadpisanie istniejących zadań dla tych użytkowników.",
      unknownUser: "User ID: {id}"
   },

   tasks: {
      addTask: "Dodaj zadanie",
      confirmDelete: "Czy na pewno chcesz usunąć zadanie?",
      types: {
         dyzurTelefoniczny: "Dyżur telefoniczny",
         spotkanieInformacyjne: "Spotkanie informacyjne",
         wizytaHotelowa: "Wizyta hotelowa",
         wycieczkaFakultatywna: "Wycieczka fakultatywna",
         biuro: "Biuro",
         dayOff: "DAY OFF",
         inne: "Inne",
         transfer: "Transfer",
         wylot: "Wylot",
         przylot: "Przylot",
         animacja: "Animacja"
      },
      validation: {
         missingDataOneHotel:
            "Uzupełnij wszystkie dane w formularzach. W hotelu {hotels} brakuje danych.",
         missingDataManyHotels:
            "Uzupełnij wszystkie dane w formularzach. W hotelach {hotels} brakuje danych."
      }
   },

   taskForms: {
      selectTask: "Wybierz zadanie",
      taskName: "Nazwa Zadania",
      meetingPlace: "Miejsce spotkania",
      time: "Godzina",
      timeFrom: "Godzina od",
      timeTo: "Godzina do",
      assigned: "Przypisani:",
      addPerson: "Dodaj osobę",
      selectedHotels: "Wybrane hotele:",
      addHotel: "Dodaj hotel",
      notes: "Uwagi",
      selectTrip: "Wybierz wycieczkę",
      selectRoute: "Wybierz trasę",
      selectTransfer: "Wybierz transfer",
      meetingTime: "Godzina zbiórki",
      meetingPoint: "Miejsce zbiórki",
      clientTransfers: "Transfery klientów",
      showClientTransfers: "Pokaż transfery klientów",
      hideClientTransfers: "Ukryj transfery klientów",
      selectedHotelsCount: "Liczba wybranych hoteli:",
      showOnlySelectedHotels: "Pokaż tylko zaznaczone hotele",
      noResultsFor: "Brak wyników dla {query}"
   },

   animations: {
      title: "Harmonogram animacji",
      addAnimation: "Dodaj animacje"
   },

   prints: {
      title: "Wydruki PDF",
      savePdf: "Zapisz Pdf",
      saveAndPrint: "Zapisz i drukuj",
      lastGeneratedPrefix: "Ostatnio wygenerowano PDF dnia",
      lastGeneratedSuffix: " r.",
      types: {
         flight: "Wylot",
         welcome: "Serdecznie witamy",
         welcomeEnvelope: "Koperta powitalna"
      },
      themes: {
         color: "Kolor",
         blackAndWhite: "Czarno - biały "
      },
      placeholders: {
         topNotes: "Uwagi nad tabelką",
         bottomNotes: "Uwagi pod tabelką",
         resident: "Rezydent",
         emergencyNumber: "Wprowadź numer alarmowy",
         welcomeInfo: "Informacje dotyczące powitania",
         meetingsComment: "Komentarz do spotkań i dyżurów",
         selectDestination: "Wybierz kierunek",
         date: "Data",
         selectPdf: "Wybierz PDF",
         selectFormat: "Wybierz format",
         selectType: "Wybierz typ",
         selectHotel: "Wybierz hotel"
      },
      errors: {
         noPrintType: "Nie wybrano rodzaju wydruku",
         noHotel: "Nie wybrano hotelu",
         noResident: "Nie wybrano rezydenta",
         noTransfers: "Brak transferów do wygenerowania dla podanych danych"
      }
   },

   report: {
      openButton: "Generuj raport",
      dialogTitle: "Generowanie raportu",
      selectParams: "Wybierz parametry raportu:",
      dateRange: "Przedział dat:",
      users: "Użytkownicy:",
      taskType: "Typ zadania:",
      generate: "Generuj",
      generating: "Generowanie...",
      placeholders: {
         dateRange: "Wybierz przedział dat",
         users: "Wybierz użytkowników",
         taskTypes: "Wybierz typy zadań"
      }
   },

   toasts: {
      animatorNameTooShort: "Użytkownik musi mieć minimum 3 litery!",
      scheduleCleared: "Harmonogram został wyczyszczony",
      scheduleCopied: "Harmonogram został skopiowany na kolejny tydzień",
      copyVerificationError: "Błąd podczas weryfikacji kopiowania",
      copyError: "Błąd podczas kopiowania harmonogramu",
      fillAllForms: "Wypełnij wszystkie dane w formularzach!",
      // Obudowa komunikatu z handleApiError. {message} to treść z backendu i zostaje
      // dokładnie taka, jaka przyszła z serwera - tłumaczymy tylko ramkę wokół niej.
      apiError: "Błąd {status}: {message}",
      apiErrorNoStatus: "Błąd: {message}",
      unknownError: "Wystąpił nieznany błąd",
      errorParseFailed: "Nie udało się odczytać treści błędu"
   },

   pdf: {
      welcome: {
         headerBadge: "Witamy serdecznie",
         resident: "Rezydent",
         medicalAssistance: "Pomoc medyczna",
         emergencyPhone: "Telefon alarmowy",
         meetings: "Spotkania",
         infoMeeting: "Spotkanie informacyjne",
         hotelVisit: "Wizyta hotelowa",
         phoneDuty: "Dyżur telefoniczny",
         date: "Data",
         time: "Godzina",
         place: "Miejsce",
         from: "Od",
         to: "Do",
         phoneContact: "Kontakt telefoniczny",
         insurance:
            "W ramach wycieczki jesteście Państwo ubezpieczeni w Towarzystwie Ubezpieczeń EUROPA S.A.",
         policyIntro: "Numer zbiorczej polisy dla wszystkich klientów Rainbow Tours S.A. to ",
         lifeThreatening: "Jeżeli sytuacja zagraża życiu Turysty ",
         lifeThreateningBold: "należy wezwać pogotowie!",
         nonLifeThreatening:
            "Gdy sytuacja nie zagraża życiu Turysty, lecz wskazana jest pomoc medyczna, wówczas prosimy przede wszystkim o kontakt z ",
         helpCentreBold: "CENTRUM POMOCY, czynne całą dobę: +48 22 568 98 28",
         polishSpeaking: "Konsultanci mówiący po polsku zorganizują dla Państwa wizytę lekarską.",
         noticeText:
            " Każdy Turysta korzystajacy z pomocy medycznej w ramach ubezpieczenia TU EUROPA ma obowiązek skontaktowania się z CENTRUM POMOCY. Po skontaktowaniu się z CENTRUM POMOCY należy zatelefonować na numer alarmowy Rainbow w celu poinformowania dyżurującego rezydenta o zdarzeniu.",
         emergencyText1:
            "Z przyjemnością odpowiemy na Państwa wszystkie pytania w trakcie spotkania powitalnego i wizyt hotelowych. Jeżeli jednak sprawa jest wyjątkowo pilna, rezydent dyżurny zawsze jest do Państwa dyspozycji. Można się z nim skontaktować pod nr tel. alarmowego.",
         emergencyText2:
            "Może się zdarzyć, iż rezydent nie będzie mógł odebrać połączenia ze względu na słaby zasięg telefonii komórkowej lub prowadzenia wycieczki lokalnej. W takiej sytuacji należy skontaktować się z naszym lokalnym biurem, gdzie również można uzyskać pomoc.",
         meetingsText:
            "Serdecznie zapraszamy na spotkania z rezydentem. Pierwsze - powitalne - służy przekazaniu praktycznych informacji nt. kierunku wakacyjnego i organizacji pobytu. W trakcie tygodnia rezydent jest także do Państwa dyspozycji podczas wizyt hotelowych wg. harmonogramu:"
      },
      flight: {
         headerBadge: "Wylot do Polski",
         title: "Miejsca i godziny wyjazdów",
         transferInfo: "Informacje transferowe dla wylotów w dniu:",
         importantInfo: "WAŻNE INFORMACJE! Prosimy koniecznie przeczytać!",
         detailedInfo: "Szczegółowe informacje dotyczące wylotów",
         checkTransferTime:
            "Proszę sprawdzić godzinę transferu na lotnisko przed wejściem na miejsce zbiórki, możliwe zmiany w ostatniej chwili!",
         table: {
            departureTo: "Wylot do",
            flightNumber: "Numer lotu",
            meetingLocalTime: "Zbiórka (czas lokalny)",
            departureLocalTime: "Wylot (czas lokalny)",
            arrivalPolishTime: "Przylot (czas polski)",
            baggageAllowance: "Limit bagażu",
            notes: "Uwagi"
         }
      }
   }
};

export default pl;
